<div class="app-copy">
    <a [href]="imprintUrl" rel="noopener noreferrer" target="_blank">{{ imprintLabel }}</a>
    <a [href]="privacyUrl" rel="noopener noreferrer" target="_blank">{{ privacyLabel }}</a>
    <a [href]="termsUrl" rel="noopener noreferrer" target="_blank">{{ termsLabel }}</a>
    <a href="javascript:UC_UI.showSecondLayer();">{{ cookieLabel }}</a>
</div>
